import { Component } from 'react'
import Button from '../Button'

// Bir sekmedeki hata sadece o sekmeyi etkiler, diğer sekmeler çalışmaya devam eder
class TabErrorBoundary extends Component {
    state = { error: null }

    static getDerivedStateFromError(error) {
        return { error }
    }

    componentDidCatch(error, info) {
        console.error(error, info)
    }

    render() {
        if (!this.state.error) return this.props.children

        return (
            <div className='flex flex-col items-center gap-y-3 py-10 text-zinc-700 dark:text-zinc-100'>
                <label>Bu sekmede bir hata oluştu.</label>
                <Button text='Sekmeyi yenile' variant='blue' onClick={this.props.onReload} />
            </div>
        )
    }
}

export default TabErrorBoundary
